import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { CoachClientDetailPage } from 'pages/coach-client-detail/coach-client-detail';

@NgModule({
  declarations: [CoachClientDetailPage],
  imports: [PagesModule, ComponentsModule],
  exports: [CoachClientDetailPage],
})
export class CoachClientDetailPageModule {}
